module.exports = __webpack_public_path__ + "static/media/2.96cc442d.jpg";